import { ListChecks } from 'lucide-react';
import type { NavModule } from '../../lib/navigation';

export const checklistsNav: NavModule = {
  id: 'checklists',
  label: 'RMS & VMS Analyze',
  icon: ListChecks,
  capability: { domain: 'checklists', action: 'read' },
  children: [
    { id: 'checklists-analyze', label: 'RMS Change Impacts', path: '/checklists' },
    { id: 'checklists-rms-customization', label: 'RMS Customization', path: '/checklists/rms' },
  ],
};
